module.exports = __webpack_public_path__ + "img/kefu_info.f34ee18a.svg";